import { useDispatch } from 'react-redux';
import { changePaginationAction, changeSearchAction } from '../../../store/projects/actions';

/**
 * Custom hook that encapsulates all action dispatchers for the HomePage
 */
export const useHomePageActions = () => {
  const dispatch = useDispatch();

  const handleSearchChange = (searchTerm: string) => {
    dispatch(changeSearchAction(searchTerm));
  };

  const handlePageChange = (newPage: number) => {
    dispatch(changePaginationAction({ page: newPage }));
    scrollTo({ top: 0 });
  };

  return {
    handleSearchChange,
    handlePageChange,
  };
};
